import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Input, Row, message, Typography } from "antd";
import { LockOutlined, UserOutlined, LoginOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const Login = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Ekran boyutunu kontrol et
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    setErrorMessage('');
    
    const { username, password } = values;

    // Basic Auth için kullanıcı adı ve şifreyi encode et
    const credentials = btoa(`${username}:${password}`);
    const url = "https://wfh4zanzfa.execute-api.eu-central-1.amazonaws.com/api1/analytics";

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Basic ${credentials}`,
        },
      });

      if (response.ok) {
        // Başarılı giriş işlemi
        const mockUser = {
          name: username,
          role: 'User',
        };
        sessionStorage.setItem('token', credentials);
        sessionStorage.setItem('user', JSON.stringify(mockUser));
        message.success('Giriş başarılı!');
        navigate('/dashboard');
      } else {
        // Başarısız giriş
        setErrorMessage('Kullanıcı adı veya şifre hatalı.');
        message.error('Giriş başarısız!');
      }
    } catch (error) {
      setErrorMessage('Bağlantı hatası. Lütfen tekrar deneyin.');
      message.error('Bağlantı hatası!');
    }
    
    setLoading(false);
  };

  return (
    <Row 
  style={{ 
    minHeight: '100vh', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    background: '#f5f7ff', // Sade çok açık mavi-beyaz ton
    padding: isMobile ? '20px' : '40px'
  }}
>
  <Col xs={24} sm={20} md={14} lg={10} xl={8} xxl={6}>
    <Card 
      style={{ 
        width: '100%',
        maxWidth: '450px',
        margin: '0 auto',
        borderRadius: '12px',
        border: '1px solid #e3e7ff',
        boxShadow: '0 4px 14px rgba(0,0,0,0.05)', // çok hafif gölge
        background: 'white'
      }}
      bodyStyle={{
        padding: isMobile ? '24px' : '40px'
      }}
    >

      {/* Logo */}
      <div style={{ 
        textAlign: 'center', 
        marginBottom: isMobile ? '24px' : '32px' 
      }}>
        <div style={{
          width: isMobile ? '60px' : '80px',
          height: isMobile ? '60px' : '80px',
          borderRadius: '50%',
          background: '#52c41a', // düz mavi
          margin: '0 auto 16px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <UserOutlined style={{ 
            fontSize: isMobile ? '26px' : '32px', 
            color: 'white' 
          }} />
        </div>

        <Title level={isMobile ? 3 : 2} style={{ marginBottom: '4px' }}>
          Octoopi Dashboard
        </Title>

        <Text type="secondary" style={{ fontSize: isMobile ? '14px' : '15px' }}>
          Hoş geldiniz, giriş yapın
        </Text>
      </div>

      <Form 
        name="login_form" 
        className="login-form" 
        onFinish={handleSubmit}
        layout="vertical"
        size={isMobile ? 'large' : 'large'}
      >
        <Form.Item 
          name="username" 
          rules={[
            { required: true, message: 'Kullanıcı adı gereklidir!' }
          ]}
        >
          <Input 
            prefix={<UserOutlined style={{ color: '#8c8c8c' }} />} 
            placeholder="Kullanıcı Adı" 
            autoComplete="username"
            style={{
              borderRadius: '8px',
              border: '1px solid #d9d9d9',
              height: isMobile ? '44px' : '48px',
              background: '#ffffff'
            }}
          />
        </Form.Item>
        
        <Form.Item 
          name="password" 
          rules={[
            { required: true, message: 'Şifre gereklidir!' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined style={{ color: '#8c8c8c' }} />} 
            placeholder="Şifre" 
            autoComplete="current-password"
            style={{
              borderRadius: '8px',
              border: '1px solid #d9d9d9',
              height: isMobile ? '44px' : '48px',
              background: '#ffffff'
            }}
          />
        </Form.Item>

        {errorMessage && (
          <div style={{ 
            color: '#ff4d4f', 
            textAlign: 'center',
            marginBottom: '16px',
            fontSize: isMobile ? '13px' : '14px',
            padding: '8px',
            backgroundColor: '#fff2f0',
            borderRadius: '6px',
            border: '1px solid #ffccc7'
          }}>
            {errorMessage}
          </div>
        )}

        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            block
            loading={loading}
            icon={<LoginOutlined />}
            style={{
              height: isMobile ? '44px' : '48px',
              borderRadius: '8px',
              fontSize: isMobile ? '15px' : '16px',
              fontWeight: '500',
              background: '#52c41a', // düz mavi
              border: 'none'
            }}
          >
            Giriş Yap
          </Button>
        </Form.Item>
      </Form>

      <div style={{ 
        textAlign: 'center', 
        marginTop: '20px',
        paddingTop: '16px',
        borderTop: '1px solid #f0f0f0'
      }}>
        <Text type="secondary" style={{ fontSize: isMobile ? '12px' : '13px' }}>
          © 2026 Octoopi Dashboard
        </Text>
      </div>

    </Card>
  </Col>
</Row>

  );
};

export default Login;